import React from 'react';
import { SectionWrapper } from 'components/atoms/SectionWrapper.style';
import Slider from 'components/organisms/mainPageComponents/slider/Slider';
import MainPageImg from 'components/organisms/mainPageComponents/mainPageImg/MainPageImg';
import styled from 'styled-components';
import { cms } from 'assets/cms';
import Header from 'components/organisms/header/Header';
import CounterWrapper from 'components/organisms/mainPageComponents/Counters/CounterWrapper';

const WrapperBackground = styled.div`
  height: 100%;
  background: center url(${cms.elgreen.lisc});
  /* background-size: contain; */
`;

const AboutUs = () => (
  <>
    <Header />
    <MainPageImg />
    <SectionWrapper>
      <Slider />
    </SectionWrapper>
    <CounterWrapper />
  </>
);

export default AboutUs;
